export const entityConstants = {
    GET_ENTITY_REQUEST: 'GET_ENTITY_REQUEST',
    GET_ENTITY_SUCCESS: 'GET_ENTITY_SUCCESS',
    GET_ENTITY_FAILURE: 'GET_ENTITY_FAILURE',

    CREATE_ENTITY_REQUEST: 'CREATE_ENTITY_REQUEST',
    CREATE_ENTITY_SUCCESS: 'CREATE_ENTITY_SUCCESS',
    CREATE_ENTITY_FAILURE: 'CREATE_ENTITY_FAILURE',

    UPDATE_ENTITY_REQUEST: 'UPDATE_ENTITY_REQUEST',
    UPDATE_ENTITY_SUCCESS: 'UPDATE_ENTITY_SUCCESS',
    UPDATE_ENTITY_FAILURE: 'UPDATE_ENTITY_FAILURE',

    DELETE_ENTITY_REQUEST: 'DELETE_ENTITY_REQUEST',
    DELETE_ENTITY_SUCCESS: 'DELETE_ENTITY_SUCCESS',
    DELETE_ENTITY_FAILURE: 'DELETE_ENTITY_FAILURE',

    VERIFY_ENTITIES_REQUEST: 'VERIFY_ENTITIES_REQUEST',
    VERIFY_ENTITIES_SUCCESS: 'VERIFY_ENTITIES_SUCCESS',
    VERIFY_ENTITIES_FAILURE: 'VERIFY_ENTITIES_FAILURE',

    REORDER_ENTITIES_REQUEST: 'REORDER_ENTITIES_REQUEST',
    REORDER_ENTITIES_SUCCESS: 'REORDER_ENTITIES_SUCCESS',
    REORDER_ENTITIES_FAILURE: 'REORDER_ENTITIES_FAILURE',


};
